import React from 'react';
import { connect } from 'react-redux';

const Authenticating = ({ message }) => (
    <div className="wrapper wrapper-full-page">
        <div className="full-page login-page" data-color="black">
            <div className="content">
                <div className="container">
                    <div className="row">
                        <div className="col-md-4 col-sm-6 col-md-offset-4 col-sm-offset-3">
                            <div style={{
                                backgroundColor: 'white',
                                borderRadius: '8px',
                                padding: '30px',
                                boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
                                textAlign: 'center'
                            }}>
                                <div className="spinner-border text-primary" role="status" style={{
                                    width: '3rem',
                                    height: '3rem',
                                    marginBottom: '1rem'
                                }}>
                                    <span className="sr-only">Chargement...</span>
                                </div>
                                <h4 style={{ marginBottom: '10px', color: '#333' }}>
                                    Chargement...
                                </h4>
                                <p style={{ color: '#666', marginBottom: 0 }}>
                                    {message || 'Veuillez patienter pendant le chargement de l\'application'}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
);

const mapStateToProps = state => ({
    message: state.status.message?.message
});

export default connect(mapStateToProps)(Authenticating);
